module.exports = __webpack_public_path__ + "static/Advantage02@1x.d5579d29.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/events/new/Advantage02@1x.png
// module id = 686
// module chunks = 216210090109534